import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { RasterCategoryDto } from 'src/app/server-api/models';
import { RasterCategoryControllerService } from 'src/app/server-api/services';
import { DropdownComponent } from 'src/app/utils-flc/dropdown/dropdown.component';

@Component({
  selector: 'app-raster-category-dropdown',
  templateUrl: './raster-category-dropdown.component.html',
  styleUrls: ['./raster-category-dropdown.component.css']
})
export class RasterCategoryDropdownComponent extends DropdownComponent {

  constructor(private rasterCatService: RasterCategoryControllerService,
    public override translate: TranslateService,
    public override fb: FormBuilder
    ) {
    super(translate, fb);
  }

  override ngOnInit(): void {

    this.placeholderText = 'raster-category-dropdown.choose';

    super.ngOnInit();
  }

  override getItems(): void {

    super.getItems();
    this.rasterCatService.getRasterCategories({ sort: ['name'], size:999 }).subscribe(
      value  => {
        this.items = value['content'] as RasterCategoryDto[];
        this.setPreSelect(this.preSelect);
      }
      ,
      error => console.error(JSON.stringify(error)),
      
      );
  }

 
}

